"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const usePagination_1 = __importDefault(require("@mui/material/usePagination"));
const base_ui_components_atoms_icon_1 = __importDefault(require("@motorata/base-ui.components.atoms.icon"));
const Pagination = ({ defaultPage, totalPages, onChange, }) => {
    const { items } = (0, usePagination_1.default)({
        defaultPage: defaultPage,
        count: totalPages,
        onChange: (e, page) => {
            onChange(page);
        }
    });
    return (react_1.default.createElement(PaginationWrapper, null, items.map((_a, index) => {
        var { page, type, selected } = _a, item = __rest(_a, ["page", "type", "selected"]);
        let children = null;
        if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = "…";
        }
        else if (type === "page") {
            children = (react_1.default.createElement(PaginationNumber, Object.assign({ key: index, active: selected }, item), page));
        }
        else {
            children = (react_1.default.createElement(PaginationNumber, Object.assign({ arrow: true }, item),
                react_1.default.createElement(base_ui_components_atoms_icon_1.default, { icon: type === "next" ? "arrow-right" : "arrow-left" })));
        }
        return children;
    })));
};
exports.Pagination = Pagination;
exports.default = exports.Pagination;
const PaginationNumber = styled_components_1.default.button `
  color: ${({ theme }) => theme.color.second};
  font-size: ${({ theme }) => theme.font.M};
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 600;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 2px;
  border-radius: 3px;

  svg {
    width: ${({ theme }) => theme.font.M};
  }

  &:hover{
    color: ${({ theme }) => theme.color.primary};
  }
  
  ${({ active }) => active &&
    (0, styled_components_1.css) `
      background: ${({ theme }) => theme.color.primary} !important;
      color: white !important;
    `}

  ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
      opacity: 0.2;
      cursor: not-allowed;
    `}

  ${({ arrow }) => arrow &&
    (0, styled_components_1.css) `
      font-size: 10px;
    `}
`;
const PaginationWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  margin-top: ${({ theme }) => theme.space.M};
  margin-bottom: ${({ theme }) => theme.space.M};
`;
//# sourceMappingURL=Pagination.js.map